"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdNumber = IdNumber;
const ValidationResult_1 = require("../ValidationResult");
const types_1 = require("./types");
const ninUtils_1 = require("../../utils/ninUtils");
const dateUtils_1 = require("../../utils/dateUtils");
const elevenDigits = /^[0-9]{11}$/;
const D_NUMBER_OFFSET = 40;
function IdNumber(idNumber) {
    if (!idNumber || !elevenDigits.test(idNumber)) {
        return {
            validationResult: (0, ValidationResult_1.error)(types_1.IdNumberErrorCode.ID_NUMBER_INVALID, types_1.IdNumberErrorMessage.ID_NUMBER_INVALID),
            value: idNumber,
        };
    }
    const idNumberType = getIdNumberType(idNumber);
    if (!idNumberType) {
        return {
            validationResult: (0, ValidationResult_1.error)(types_1.IdNumberErrorCode.ID_NUMBER_INVALID, types_1.IdNumberErrorMessage.ID_NUMBER_INVALID),
            value: idNumber,
        };
    }
    const dd = (0, ninUtils_1.dayFrom)(idNumber);
    const mm = (0, ninUtils_1.monthFrom)(idNumber);
    const yy = (0, ninUtils_1.yearFrom)(idNumber);
    const identityDigits = (0, ninUtils_1.individsifreFrom)(idNumber);
    const control1 = parseInt(idNumber.substring(9, 10), 10);
    const control2 = parseInt(idNumber.substring(10, 11), 10);
    const birthDate = getBirthDate(dd, mm, yy, identityDigits, idNumberType);
    if (!birthDate) {
        return {
            validationResult: (0, ValidationResult_1.error)(types_1.IdNumberErrorCode.ID_NUMBER_INVALID_DATE, types_1.IdNumberErrorMessage.ID_NUMBER_INVALID_DATE),
            value: idNumber,
        };
    }
    const calculatedControl1 = (0, ninUtils_1.calculateNinControl1)(dd, mm, yy, identityDigits);
    if (calculatedControl1 === undefined || calculatedControl1 !== control1) {
        return {
            validationResult: (0, ValidationResult_1.error)(types_1.IdNumberErrorCode.ID_NUMBER_INVALID_CONTROL_ONE, types_1.IdNumberErrorMessage.ID_NUMBER_INVALID_CONTROL_ONE),
            value: idNumber,
        };
    }
    const calculatedControl2 = (0, ninUtils_1.calculateNinControl2)(dd, mm, yy, identityDigits, control1);
    if (calculatedControl2 === undefined || calculatedControl2 !== control2) {
        return {
            validationResult: (0, ValidationResult_1.error)(types_1.IdNumberErrorCode.ID_NUMBER_INVALID_CONTROL_TWO, types_1.IdNumberErrorMessage.ID_NUMBER_INVALID_CONTROL_TWO),
            value: idNumber,
        };
    }
    return {
        birthDate: birthDate,
        gender: getGender(identityDigits),
        type: idNumberType,
        validationResult: { valid: true },
        value: idNumber,
    };
}
function getDayOfBirth(dd, idNumberType) {
    switch (idNumberType) {
        case "Nin":
            return Number(dd);
        case "DNumber":
            return Number(dd) - D_NUMBER_OFFSET;
        default:
            return null;
    }
}
function getFullYear(yy, identityDigits, idNumberType) {
    const yearAsNumber = Number(yy);
    let centuryPrefix = "20";
    if (0 <= identityDigits && identityDigits <= 499) {
        centuryPrefix = "19";
    }
    else if (idNumberType === "DNumber") {
        centuryPrefix = "20";
    }
    else if (500 <= identityDigits &&
        identityDigits <= 749 &&
        yearAsNumber >= 54) {
        centuryPrefix = "18";
    }
    else if (900 <= identityDigits &&
        identityDigits <= 999 &&
        yearAsNumber >= 40) {
        centuryPrefix = "19";
    }
    return Number(`${centuryPrefix}${yy}`);
}
function getBirthDate(dd, mm, yy, identityDigits, idNumberType) {
    const day = getDayOfBirth(dd, idNumberType);
    if (!day) {
        return null;
    }
    const month = Number(mm);
    const year = getFullYear(yy, Number(identityDigits), idNumberType);
    const date = new Date(year, month - 1, day);
    if (!(0, dateUtils_1.isValidDate)(date, month)) {
        return null;
    }
    return date;
}
function getIdNumberType(idNumber) {
    const firstDigit = Number(idNumber.substring(0, 1));
    if (0 <= firstDigit && firstDigit <= 3) {
        return "Nin";
    }
    if (4 <= firstDigit && firstDigit <= 7) {
        return "DNumber";
    }
    return null;
}
function getGender(identityDigits) {
    const genderDigit = Number(identityDigits.charAt(2));
    return genderDigit % 2 === 0 ? "Female" : "Male";
}
//# sourceMappingURL=IdNumberValidator.js.map